import { AgencyNoticeDto } from "../dtos/agency-notice.dto";
import { AgencyNotice } from "../models/agency-notice.model";

export const parseAgencyNotice = (dto: AgencyNoticeDto): AgencyNotice => {
  const agencyNotice: AgencyNotice = {
    token: dto.token,
    targetScope: dto.target_scope,
    dismiss_type: dto.dismiss_type,
    exhibition: dto.exhibition,
    type: dto.type,
    widget: dto.widget,
    content: dto.content,
    createdAt: new Date(dto.created_at),
    updatedAt: new Date(dto.updated_at),
  };

  return agencyNotice;
};

export const parseAgencyNotices = (dtos: AgencyNoticeDto[]): AgencyNotice[] => {
  return dtos.map((dto) => parseAgencyNotice(dto));
};
